<template>
  <div>
    <Drawer v-model="drawer" width="400" :title="searchItem.no + '订单进程'">
      <Steps
        v-if="nodes.length > 0"
        :current="0"
        direction="vertical"
        id="absec"
      >
        <Step
          :icon="index == 0 ? 'md-alarm' : 'md-arrow-up'"
          v-for="(item, index) in nodes"
          :key="index"
          :title="item.name"
        >
          <template slot="content">
            <ly-form-item label="时间">{{ item.intime }}</ly-form-item
            ><ly-form-item label="相关说明">{{ item.remark }}</ly-form-item>
            <ly-form-item
              v-show="!utils.isEmpty(item.carNo)"
              label="大陆车牌"
              >{{ item.carNo }}</ly-form-item
            >
            <ly-form-item
              v-show="!utils.isEmpty(item.driver)"
              label="大陆司机"
              >{{ item.driver }}</ly-form-item
            >
            <ly-form-item
              v-show="!utils.isEmpty(item.carNoHk)"
              label="香港车牌"
              >{{ item.carNoHk }}</ly-form-item
            >
            <ly-form-item
              v-show="!utils.isEmpty(item.driverHk)"
              label="香港司机"
              >{{ item.driverHk }}</ly-form-item
            >
          </template>
        </Step>
      </Steps>
      <p v-else>暂无数据</p>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchItem: { no: "" },
      drawer: false,
      nodes: [],
    };
  },
  methods: {
    reach(v) {
      this.drawer = true;
      this.no = v.no;
      this.searchItem.no = v;
      this.getData();
    },
    getData() {
      ///cloud-tms-server-omc/transportNode/info
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/transportNode/info",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        var aa = "1_2";
        for (let i = 0; i < data.length; i++) {
          //var a = data[i].address.split("_");
          //data[i].title = a[0];
          //data[i].address1 = a[1];
          data[i].intime = this.utils.time(data[i].inTime, "yymmddhhmm");
          //data[i].outtime = this.utils.time(data[i].outTime, "yymmddhhmm");
        }
        console.log(data);
        this.nodes = data;
      });
    },
  },
};
</script>
<style>
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-title {
  color: #333;
}
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner span,
#absec
  .ivu-steps-item.ivu-steps-status-wait
  .ivu-steps-head-inner
  > .ivu-steps-icon {
  color: #2d8cf0;
}
#absec .ivu-steps-item.ivu-steps-status-wait .ivu-steps-content {
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/common/jiedian.vue